// extracted by mini-css-extract-plugin
export default {"game-area":"SnakeGame_game-area__iK4jW","container":"SnakeGame_container__73JSC","navigationButton":"SnakeGame_navigationButton__eYy8P"};